import React from 'react';
import { classNames } from 'primereact/utils';
import styles from './DualTextCard.module.scss';

interface DualTextCardProps {
  title1: string;
  detail1: string;
  title2: string;
  detail2: string;
  backgroundColor: string;
  dividerColor: string;
  textColor: string;
  icon?: string;
  className?: string;
}

const DualTextCard: React.FC<DualTextCardProps> = ({
  title1,
  detail1,
  title2,
  detail2,
  backgroundColor,
  dividerColor,
  textColor,
  icon,
  className,
}) => {
  return (
    <div
      className={classNames(styles.card, className)}
      style={{ backgroundColor }}
    >
      <div className={styles.icon}>
        <img src={icon} alt="card-icon" />
      </div>
      <div className={styles.content}>
        <div className={styles.textSection}>
          <span className={styles.title} style={{ color: textColor }}>
            {title1}
          </span>
          <span className={styles.detail} style={{ color: textColor }}>
            {detail1}
          </span>
        </div>
        <div
          className={styles.divider}
          style={{ backgroundColor: dividerColor }}
        />
        <div className={styles.textSection}>
          <span className={styles.title} style={{ color: textColor }}>
            {title2}
          </span>
          <span className={styles.detail} style={{ color: textColor }}>
            {detail2}
          </span>
        </div>
      </div>
    </div>
  );
};

export default DualTextCard;
